import React from 'react';
import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import { useWatch } from 'react-hook-form';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import { materialSymbolsOutlined } from '@lib/enums/common';
import { FieldNames, FormTypeValue } from 'components/GenerateReportForm/types';

interface Props {
  loading: boolean;
  onCancel: () => void;
}

function GenerateReportFormActions(props: Props) {
  const { loading, onCancel } = props;
  const watch = useWatch();
  const formType = _get(watch, [FieldNames.FormType, 'value']);
  const isEmail = formType === FormTypeValue.Email;
  const { t } = useTranslation();
  return (
    <ActionsRow
      actions={[
        <Button
          key="cancel"
          buttonType={ButtonTypes.secondaryOutlined}
          buttonText={t('cancel')}
          leftIcon="close"
          onClick={onCancel}
          fullWidth
          disabled={loading}
        />,
        <Button
          key="submit"
          type="submit"
          buttonType={ButtonTypes.primaryFilled}
          buttonText={isEmail ? t('send-pdf') : t('export-pdf')}
          leftIcon={isEmail ? 'send' : 'check'}
          leftIconClassName={materialSymbolsOutlined}
          fullWidth
          disabled={loading}
        />,
      ]}
    />
  );
}

export default GenerateReportFormActions;
